var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.2C6.035 1.2 1.2 6.035 1.2 12c0 5.965 4.835 10.8 10.8 10.8 5.965 0 10.8-4.835 10.8-10.8 0-5.965-4.835-10.8-10.8-10.8zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.554 14.396h-1.692v-.864c0-.312.03-.594.09-.846s.144-.48.252-.684c.12-.204.258-.396.414-.576.168-.192.354-.384.558-.576l.666-.63c.264-.228.48-.474.648-.738.18-.276.27-.624.27-1.044 0-.576-.186-1.032-.558-1.368-.36-.348-.828-.522-1.404-.522-.6 0-1.08.192-1.44.576-.36.384-.57.852-.63 1.404L8 8.33c.072-.516.222-.978.45-1.386.228-.42.51-.774.846-1.062a3.573 3.573 0 011.188-.648A4.26 4.26 0 0111.906 5c.504 0 .972.072 1.404.216.444.144.834.36 1.17.648.336.276.6.624.792 1.044.192.408.288.882.288 1.422 0 .384-.042.72-.126 1.008a2.97 2.97 0 01-.36.792 3.367 3.367 0 01-.54.648c-.216.204-.45.414-.702.63-.24.204-.444.39-.612.558-.168.156-.3.318-.396.486a2.076 2.076 0 00-.216.558 4.45 4.45 0 00-.054.756v.63zm.45 2.538c0 .312-.114.588-.342.828a1.14 1.14 0 01-.864.36 1.21 1.21 0 01-.864-.342 1.167 1.167 0 01-.342-.828c0-.324.114-.6.342-.828.228-.24.516-.36.864-.36s.636.114.864.342c.228.228.342.504.342.828z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.702bce1ce96cbf2c0792952f7ab01979.svg";
export { ForwardRef as ReactComponent };